import React from "react";
import { Folder, Code2, TerminalSquare, Globe } from "lucide-react";

const TABS = [
  { id: "files",    label: "Files",    Icon: Folder },
  { id: "editor",   label: "Editor",   Icon: Code2 },
  { id: "terminal", label: "Terminal", Icon: TerminalSquare },
  { id: "preview",  label: "Preview",  Icon: Globe },
];

export default function MobileBottomTabs({ active, onChange, previewEnabled }) {
  return (
    <nav
      className="flex items-stretch border-t border-ide-border bg-ide-panel2 select-none flex-none w-full"
      style={{
        // Safe-area bottom inset so the tab bar sits above the iOS home
        // indicator and any inset toolbars. The flex-column parent pins this
        // element to the bottom of the dvh, so it never scrolls away.
        paddingBottom: "max(0px, env(safe-area-inset-bottom, 0px))",
        zIndex: 40,
      }}
    >
      {TABS.map(({ id, label, Icon }) => {
        const isActive = active === id;
        const disabled = id === "preview" && !previewEnabled;
        return (
          <button
            key={id}
            disabled={disabled}
            onClick={() => !disabled && onChange?.(id)}
            data-testid={`mobile-tab-${id}`}
            className={
              "relative flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] transition-colors min-h-[52px] " +
              (disabled
                ? "text-ide-mute opacity-40 cursor-not-allowed"
                : isActive
                ? "text-ide-accent"
                : "text-ide-mute hover:text-ide-text")
            }
            aria-label={label}
            aria-current={isActive ? "page" : undefined}
          >
            <Icon className={"h-4 w-4 " + (isActive ? "text-ide-accent" : "")} />
            <span>{label}</span>
            {isActive && (
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 h-0.5 w-7 bg-ide-accent rounded-full" />
            )}
          </button>
        );
      })}
    </nav>
  );
}
